import React, { Component } from 'react';
import StyleSheet from 'stilr';
import ResultRow from './result-row';
import { List } from 'immutable';
import storage from '../../../lib/storage';
import { palm } from 'react-flexr';
import DisplayResults from './displayResults';

const styles = StyleSheet.create({
  container: {
    counterReset: 'section',
    marginBottom: '2em'
  },
  resultContainer: {
    position: 'relative',
    marginBottom: '2em',

    ':not(.hidden):before': {
      font: 'normal 15px/15px arial, sans-serif',
      position: 'absolute',
      left: -8,
      top: -8,
      minWidth: 25,
      textAlign: 'center',
      backgroundColor: '#d3d3d3',
      padding: 5,
      borderRadius: 15,
      border: '1px solid #d3d3d3',
      color: '#333333',
      zIndex: 10,
      counterIncrement: 'section',
      content: 'counter(section)'
    }
  },

  resultDiscounted: {
    ':not(.hidden):before': {
      backgroundColor: '#FFEE00',
      borderColor: '#FFDD00',
      color: '#000000'
    }
  },

  moreContainer: {
    margin: '1em auto 2em',
    textAlign: 'center'
  },
  moreBtn: {
    minWidth: '30%'
  },
  separator: {
    display: 'flex',
    alignItems: 'center',
    margin: '15px',

    ':before': {
      flex: '1',
      content: '""',
      padding: '1px',
      backgroundColor: 'lightgrey',
      margin: '10px'
    },
    ':after': {
      flex: '1',
      content: '""',
      padding: '1px',
      backgroundColor: 'lightgrey',
      margin: '10px'
    }
  }
});

class Results extends Component {
  static defaultProps = {
    limit: 10
  };

  constructor(props) {
    super(props);

    this.state = this.reduceResults(props);
    this.setState({ showAll: false });
  }

  componentWillReceiveProps(nextProps) {
    this.reduceResults(nextProps);
  }

  showMore = () => {
    storage.set(this.props.category, '1');
    this.setState(this.reduceResults(this.props));
    this.setState({ showAll: true });
    // this.forceUpdate();
    // this.props.updateResults();
  };

  reduceResults(props) {
    const { results = List(), limit, filter, sort } = props || this.props || {};

    // Pre process offers (eg. cellphone calculations)
    // ...

    // Filter
    const filtered = typeof filter === 'function' ? filter(results) : results;

    // Sort
    // if (typeof sort === 'function') {
    //   filtered = sort(filtered);
    // }

    const resultsCount = filtered.size;
    // if(this.props.limitOn) {
    //   // Limit
    //   more = !storage.get(this.props.category) && resultsCount > limit;
    //   if (more) {
    //     filtered = filtered.slice(0, limit);
    //   }
    // }

    const newState = {
      filteredKeys: filtered.map(item => item.get('id')),
      results: this.props.limitOn ? ((this.state && this.state.showAll) ? filtered : filtered.slice(0, limit)) : filtered,
      filtered,
      resultsCount
    };
    this.setState(newState);

    return newState;
  }

  render() {
    const { resetFilter, staticOffersSeparator } = this.props;
    const { filteredKeys, more, resultsCount, showAll } = this.state;
    const noResult = filteredKeys.size === 0;
    const priorities = (this.state.showAll ? this.state.filtered : this.state.results).filter((i) => {
      return i.getIn(['_raw', 'priority']);
    });

    const staticOffers = this.props.addressId && this.props.staticOffers ? this.props.staticOffers : [];
    const noStatic = staticOffers.length === 0;

    return (
      <div className={styles.container}>
        { noResult ? 
        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
          <a onClick={() => resetFilter()} style={{ 
            textWrap: 'wrap',
            backgroundColor: 'rgba(255, 196, 20, 0.51)', // rgba(76, 175, 80, 0.10)
            color: 'rgb(136, 96, 0)', // rgb(76, 175, 80)
            border: '1px solid rgb(167, 132, 0)', // rgb(76, 175, 80)
            display: 'inline-block',
            fontSize: '1em',
            padding: '.3em .7em .4em .4em',
            marginTop: '0.5em',
            marginRight: '0.5em',
            fontWeight: 'normal',
            maxWidth: '600px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            ':before': {
              marginRight: 5,
              display: 'inline-block',
              font: 'normal normal normal 14px/1 FontAwesome',
              fontSize: 'inherit',
              textRendering: 'auto',
              WebkitFontSmoothing: 'antialiased',
              MozOsxFontSmoothing: 'grayscale'
            },
            [palm]: {
              fontSize: '.9em',
              maxWidth: 'calc(100vw - 60px)'
            }
          }} className={'label'}>
            <strong>{'Ingen resultater - Tryk her for at nulstille kriterier'}</strong>
          </a>
        </div>
        : null }
        {priorities.sort((a, b) => a.getIn(['_raw', 'priority']) - b.getIn(['_raw', 'priority'])).map(result => {
          const key = result.get('id');
          return (
            <div
              key={'priority_' + key.substr(-6)}
              className={[
                styles.resultContainer,
                // filteredKeys.indexOf(key) === -1 && !showAll
                //   ? 'hidden'
                //   : 
                  result.get('tagline')
                  ? styles.resultDiscounted
                  : null
              ]
                .filter(Boolean)
                .join(' ')}
            >
              <ResultRow data={result} addressId={this.props.addressId} filtersUsed={this.props.filtersUsed} siteId={this.props.siteId} feed={this.props.feed} url={this.props.url} offerType={this.props.offerType}/>
            </div>
          );
        })}
         {noResult ? null : priorities.length ? <div className={styles.separator}>Ovenstående er udvalgte - Herunder vises alle</div> : null}
         {(this.state.showAll ? this.state.filtered : this.state.results).sort((a, b) => a.get('price').get('value') - b.get('price').get('value')).map((result, idx) => {
          const key = result.get('id');
          return (
            <div
              key={key.substr(-6)}
              className={[
                styles.resultContainer,
                // filteredKeys.indexOf(key) === -1 && !showAll
                //   ? 'hidden'
                //   : 
                  result.get('tagline')
                  ? styles.resultDiscounted
                  : null
              ]
                .filter(Boolean)
                .join(' ')}
            >
              <ResultRow data={result} addressId={this.props.addressId} filtersUsed={this.props.filtersUsed} siteId={this.props.siteId} feed={this.props.feed} url={this.props.url} offerType={this.props.offerType}/>
            </div>
          );
        })}
        {noStatic ? null : <div className={styles.separator}>{staticOffersSeparator ? staticOffersSeparator : 'Ekstra tilbud'}</div>}
        {staticOffers.sort((a, b) => a.get('price').get('value') - b.get('price').get('value')).map(result => {
          const key = result.get('id') || result.get('_id');
          return (
            <div
              key={'staticOffer_' + key.substr(-6)}
              className={[
                styles.resultContainer,
                // filteredKeys.indexOf(key) === -1 && !showAll
                //   ? 'hidden'
                //   : 
                  result.get('tagline')
                  ? styles.resultDiscounted
                  : null
              ]
                .filter(Boolean)
                .join(' ')}
            >
              <ResultRow data={result} addressId={this.props.addressId} filtersUsed={this.props.filtersUsed} siteId={this.props.siteId} feed={this.props.feed} url={this.props.url} offerType={this.props.offerType}/>
            </div>
          );
        })}

        {showAll ? null : this.props.limitOn ? //|| !__CLIENT__ ? (
          (<div className={styles.moreContainer}>
            <button
              type="button"
              className={`btn btn-primary ${styles.moreBtn}`}
              onClick={this.showMore}
            >
              {`Vis alle ${resultsCount} resultater »`}
            </button>
          </div>) : null
        }
        {this.props.children}
      </div>
    );
  }
}

export default Results;
